import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { getByInviteToken } from 'actions/user';
import jwt from 'helpers/jwt';
import LoginRouter from 'containers/routers/LoginRouter';
import AppPaths from '../../../AppPaths';
import ModalPage from 'containers/pages/ModalPage/ModalPage';
import TermsAndConditions from '../../../components/TermsAndConditions';
import ModalSubHeader from '../../../components/ModalSubHeader';
import PendingUserSignUpForm from '../../../components/SignUp/pendingUserForm';
import InvalidInviteTokenForm from '../../../components/SignUp/invalidInviteTokenForm';

import { Alert } from '@shoflo/polymer/components/Alert/Alert';
const subHeaderProps = {
  message: `Already have an account?`,
  to: AppPaths.LoginPage,
  linkTitle: 'Sign in',
};

const StyledAlertContainer = styled.div`
  margin-bottom: 24px;
`;

export const SignupInvitedPage = (props) => {
  const dispatch = useDispatch();
  const { match } = props;
  const token = match.params.token;

  const [invalidJWT, setInvalidJWT] = useState(false);

  useEffect(() => {
    if (jwt.isValidToken(token)) {
      dispatch(getByInviteToken(token));
    } else {
      setInvalidJWT(true);
    }
  }, [dispatch, token]);

  const invitedUser = useSelector((state) => state.invitedUser);
  const inviteTokenExpired = useSelector((state) => state.inviteTokenExpired);

  const invalidToken = invalidJWT || inviteTokenExpired;

  return (
    <LoginRouter>
      <ModalPage
        header="Welcome to Shoflo"
        subHeader={<ModalSubHeader {...subHeaderProps} />}
        footer={<TermsAndConditions />}
      >
        {invalidToken && (
          <>
            <StyledAlertContainer>
              <Alert
                type="warning"
                title="This signup link is invalid."
                content="If you were invited to an event, you can request a new link by submitting your email below."
              />
            </StyledAlertContainer>

            <InvalidInviteTokenForm />
          </>
        )}
        {invitedUser ? (
          <PendingUserSignUpForm invitedUser={invitedUser} />
        ) : null}
      </ModalPage>
    </LoginRouter>
  );
};

SignupInvitedPage.propTypes = {
  match: PropTypes.object,
  getByInviteToken: PropTypes.func,
};

export default SignupInvitedPage;
